module.exports = __webpack_public_path__ + "media/packs/images/usb-connected-9570d8943bf963d69ab992c6e4dfef26.png";